export default function googleCalendarUrl(order) {
  // dates   時間格式為 YYYYMMDDTHHMMSS
  // details 使用 %0A 作為跳行
  const text = order.productName || '';
  const start = order.startDate
    .replace(/-/g, '')
    .replace(/:/g, '')
    .replace(/\s/g, 'T');
  const end = order.endDate
    .replace(/-/g, '')
    .replace(/:/g, '')
    .replace(/\s/g, 'T');
  const dates = `${start}/${end}`;
  const details = order.productDescription || '';
  const location = order.productAddress || '';
  const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`;

  return `http://www.google.com/calendar/event?${query}`
}
